/**
 * Url adresy jednotlivých součástí aplikace
 * @includeToDoc
 */
export interface IAppAddresses {
    /** Vrací adresu webové služby bez lomítka na konci */
    readonly serviceUrl: string;
    /** Vrací adresu klientské aplikace bez lomítka na konci */
    readonly clientUrl: string;
}
